export const APPLICATION_DETAIL_SETTINGS_LANGUAGE_LIST_DEFAULT_STATE = {
    hasError: false,
    isLoading: true,
    data: [],
};

export const APPLICATION_DETAIL_SETTINGS_USERS_ACCESS_DEFAULT_STATE = {
    hasError: false,
    isLoading: true,
    data: [],
};

export const APPLICATION_DETAIL_SETTINGS_ADDONS_AVAILABLE_DEFAULT_STATE = {
    hasError: false,
    isLoading: true,
    data: [],
};

export const APPLICATION_DETAIL_SETTINGS_ADDONS_INSTALLED_DEFAULT_STATE = {
    hasError: false,
    isLoading: true,
    data: [],
};

export const APPLICATION_DETAIL_SETTINGS_DEFAULT_STATE = {
    hasError: false,
    isLoading: false,
    isContentLanguageInitialized: false,
    data: {},
    languageList: APPLICATION_DETAIL_SETTINGS_LANGUAGE_LIST_DEFAULT_STATE,
    usersAccess: APPLICATION_DETAIL_SETTINGS_USERS_ACCESS_DEFAULT_STATE,
    addonsAvailable: APPLICATION_DETAIL_SETTINGS_ADDONS_AVAILABLE_DEFAULT_STATE,
    addonsInstalled: APPLICATION_DETAIL_SETTINGS_ADDONS_INSTALLED_DEFAULT_STATE,
    addonsScripts: {},
};

export const APPLICATION_DETAIL_SETTINGS_GUIDES_DEFAULT_STATE = {
    isLoading: false,
    hasError: false,
    data: [],
    searchTerm: '',
};

export const APPLICATION_DETAIL_THEMES_DEFAULT_STATE = {
    themeIds: {
        isLoading: false,
        hasError: false,
        data: [],
    },
    theme: {
        isLoading: false,
        hasError: false,
        data: {},
    },
};

export const APPLICATION_DETAIL_SEGMENTS_DEFAULT_STATE = {
    list: {
        hasError: false,
        isLoading: false,
        data: [],
    },
};

export const APPLICATION_DETAIL_DEFAULT_STATE = {
    settings: APPLICATION_DETAIL_SETTINGS_DEFAULT_STATE,
    guides: APPLICATION_DETAIL_SETTINGS_GUIDES_DEFAULT_STATE,
    themes: APPLICATION_DETAIL_THEMES_DEFAULT_STATE,
    segments: APPLICATION_DETAIL_SEGMENTS_DEFAULT_STATE,
};
